import Vue from "vue";
import url from "./apiurls";
import { store } from "../store/store";
import { customerApi } from "./customerApi";
import { cartApis } from "./cartApis";
import { notifications } from "../Commonjs/notificationjs";
import { teacherApi } from "./teacherApi";
import { adminAuthentication } from "./adminApis/adminAuthentication";

export const authenticationApi = new Vue({
  methods: {
    signUp(userData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.signUp, userData)
          .then(res => {
            store.dispatch("user/setLoginStatus", true);
            customerApi.getCustomerDetails(userData.role);
            if (store.state.cart.cart.length < 0) {
              cartApis.getCartDetails();
            } else {
              cartApis.insertCart(store.state.cart.cart).then(res => {
                cartApis.getCartDetails();
              });
            }
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    async login(userData) {
      if (userData.role === "teacher")
        await adminAuthentication.adminLogin(userData.email, userData.password);
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.login, userData)
          .then(res => {
            store.dispatch("user/setLoginStatus", true);
            // this.socketAuthentication(userData);
            customerApi.getCustomerDetails(userData.role);
            this.getCourseDetails(userData);
            if (userData.role === "student") {
              customerApi.getFollowingTeachers();
              customerApi.getWishlist();
              cartApis.getCartDetails().then(res => {
                cartApis.insertCart(store.state.cart.cart);
              });
            } else if (userData.role === "teacher") {
              teacherApi.getFollowingStudents();
              teacherApi.getCourseSubscribedStudents();
            }
            resolve(res);
            // notifications.connectToSocket();ss
          })
          .catch(e => {
            store.dispatch("adminAuth/clearCredentials");
            reject(e);
          });
      });
    },
    async getCourseDetails(userData) {
      if (userData.role === "student")
        await customerApi.getSubscribedCourses(userData.role);
      if (userData.role === "teacher") await customerApi.getTeacherCourses();
      store.dispatch("user/setCourseStatus", true);
      if (store.state.events.redirectToSubscription) {
        store.dispatch("events/setRedirectToSubscription", false);
      }
    },
    socketAuthentication(userData) {
      const authData = {
        email: userData.email,
        password: userData.password,
        role: userData.role,
        browser_id: "",
        session_id: ""
      };
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.SocketAuth, authData)
          .then(res => {
            notifications.connectToSocket(res.data.authTicket);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    logOut() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.logOut)
          .then(res => {
            store.dispatch("user/clearUserData");
            store.dispatch("notifications/clearNotification");
            store.dispatch("cart/addToCart", []);
            store.dispatch("adminAuth/clearCredentials");
            store.dispatch("teacher/setFollowingTeachers", []);
            resolve(res);
          })
          .catch(e => {
            store.dispatch("user/clearUserData");
            store.dispatch("notifications/clearNotification");
            store.dispatch("adminAuth/clearCredentials");
            store.dispatch("cart/addToCart", []);
            store.dispatch("teacher/setFollowingTeachers", []);
            reject(e);
          });
        notifications.disconnectSocket();
      });
    },
    editPassword(userData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.editPassword, userData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    requestPassword(email) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.requestPassword, email)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    resetPassword(userData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.resetPassword, userData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    sendOTP(otpData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.sendOTP, otpData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    verifyOTP(otpData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.verifyOTP, otpData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
});
